import {tablePointsJson} from "../utils/types";

export const tablePoints = (json: tablePointsJson) => {
    const card = document.querySelector('.card-ambassador') as HTMLDivElement

    if (!card) return

    const points = card.querySelector('.card-ambassador__points span') as HTMLSpanElement
    const tabPoints = card.querySelector('.card-ambassador__points-tab[data-state="valid"] span') as HTMLSpanElement
    const table = card.querySelector('.history__table[data-state="valid"]') as HTMLDivElement

    if (!points || !tabPoints || !table) return;

    (table.querySelectorAll('.history__row') as NodeListOf<HTMLDivElement>)?.forEach((item: HTMLDivElement) => {
        if ((item.querySelector('span:first-child') as HTMLSpanElement).innerText === "Acceptation des visites à votre domicile") {
            item.remove()
        }
    })

    json?.points?.available.forEach(item => {
        if (item.key === "Activation de la visite25") {
            const wrapper = document.createElement('div')
            wrapper.classList.add('history__row')
            const action = document.createElement('span')
            action.innerText = item?.action
            const points = document.createElement('span')
            points.innerText = String(item?.points + ' points')
            wrapper.appendChild(action)
            wrapper.appendChild(points)
            table.appendChild(wrapper)
        }
    })

    points.innerText = String(json.availablePoints)
    tabPoints.innerText = String(json.availablePoints)
}
